import { ErrorUtil } from "../../../../api/ErrorUtil";
import isBlank from "@sedan-utils/is-blank";
export class CustomApiTransformError {
    constructor(jsonData) {
        this.jsonData = jsonData;
    }
    parseError(handler) {
        this.parseErrorHandler = response => handler(response);
        return this;
    }
    static get default() {
        const basicError = new CustomApiTransformError();
        basicError.parseError(e => {
            return ErrorUtil.defaultErrorMsg;
        });
        throw basicError;
    }
    get errorDescription() {
        if (this.parseErrorHandler != null) {
            const message = this.parseErrorHandler(this);
            if (!isBlank(message)) {
                return message;
            }
        }
        return undefined;
    }
}
